// extracted by mini-css-extract-plugin
export default {"root":"WiseAddToShoppingListButton_root__ZYkAF","trigger":"WiseAddToShoppingListButton_trigger__+Uyty"};